import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDateSelected',
  standalone: true,
})
export class IsDateSelectedPipe implements PipeTransform {
  transform(day: Date, dateSelected: Date): boolean {
    return dateSelected ? day.getTime() === dateSelected.getTime() : false;
  }
}
